<template>
  <div class="contestazioni" v-loading="loading">

    <transition name="fade">
      <ricerca v-show="showSearchPanel" :prefixApp="prefixApp" @closeRicerca="closeSearch" @cerca="cerca"
        @loadingOff="setLoading(false)">
      </ricerca>
    </transition>

    <div class="header-tab col-24 no-padding row row-custom">
      <div class="col-2 no-padding icon-search">
        <el-button @click="openSearch">
          <el-tooltip class="item" effect="dark" :content="$t('contestazione.cerca')" placement="top-start">
            <icon name="riv-filter" scale="1.4"></icon>
          </el-tooltip>
        </el-button>
      </div>
      <div class="fornitore col-22 no-padding">
        <span>
          {{ fornitore }} - {{ desFornitore }}
        </span>
      </div>
    </div>

    <el-table :data="contestazioni" @sort-change="sortChange" class="custom-table">

      <el-table-column header-align="center" align="center" :label="$t('contestazione.ordine')" width="150"
        sortable="custom" prop="ordine">

        <template slot-scope="scope">
          <div class="cell no-padding">
            {{ scope.row.annoOrd }} / {{ scope.row.numOrd }}
          </div>
        </template>

      </el-table-column>

      <el-table-column header-align="center" align="center" prop="desSoc" :label="$t('contestazione.soc')" width="200">
      </el-table-column>
      <el-table-column header-align="center" align="center" prop="desMag" :label="$t('contestazione.mag')" width="200">
      </el-table-column>
      <el-table-column header-align="center" align="center" :label="$t('contestazione.dataCont')" width="200"
        prop="dataCon" sortable="custom">

        <template slot-scope="scope">
          <div class="cell no-padding">
            {{ getDataCont(scope.row)
            }}
          </div>
        </template>

      </el-table-column>
      <el-table-column prop="nominativo" :label="$t('contestazione.nominativo')" min-width="150" sortable="custom">
      </el-table-column>
      <el-table-column prop="mansione" :label="$t('contestazione.mansione')" min-width="150" sortable="custom">
      </el-table-column>
      <el-table-column width="50">
        <template slot-scope="scope">
          <div class="name-wrapper pointer action" v-if="scope.row.noteForn != ''">
            <el-tooltip placement="left">
              <div slot="content" v-html="scope.row.noteForn.split('\\n').join('\n')" style="white-space: pre-line">
              </div>
              <icon name="riv-addnotes" scale="1.2"></icon>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column width="50">
        <template slot-scope="scope">
          <div class="name-wrapper pointer action" @click="selectContestazione(scope.row)">
            <icon name="riv-searchPas" scale="1.2"></icon>
          </div>
        </template>
      </el-table-column>
    </el-table>


    <el-pagination v-if="(nrPages > 1)" :current-page="currentPage" class="custom-pagination" background
      layout="prev, pager, next" :total="nrItems" :page-size="pag_for" @current-change="changePage">
    </el-pagination>

  </div>
</template>

<script>
import Ricerca from './Ricerca.vue'
import { bus } from '@/components/Bus.js'
import moment from 'moment'

export default {
  name: 'ElencoContestazioni',
  components: { Ricerca },
  i18n: {
    messages: {
      it_IT: {
        contestazione: {
          cerca: 'Cerca',
          ordine: 'Ordine',
          soc: 'Società',
          mag: 'Magazzino',
          dataCont: 'Data Contestazione',
          nominativo: 'Nominativo',
          mansione: 'Mansione'
        }
      },
      fr_FR: {
        contestazione: {
          cerca: 'Rechercher',
          nuovoDip: 'Nouvel employé',
          contestazione: 'Employé',
          dataNascita: 'Né le',
          luogoNascita: 'Né à',
          sesso: 'Sexe',
          dataAssunzione: 'Embauché le',
          dataCessazione: 'Cessation le',
          mansione: 'Tâche',
          tipoRapp: 'Type de rapport'
        }
      },
      es_ES: {
        contestazione: {
          cerca: 'Buscar',
          nuovoDip: 'Nuevo Empleado',
          contestazione: 'Empleado',
          dataNascita: 'Nacido el',
          luogoNascita: 'Nacido en',
          sesso: 'Sexo',
          dataAssunzione: 'Contratado el',
          dataCessazione: 'Cesado el',
          mansione: 'Tarea',
          tipoRapp: 'Tipo de relacion'
        }
      },
      de_DE: {
        contestazione: {
          cerca: 'Suche',
          nuovoDip: 'Neuer Mitarbeiter',
          contestazione: 'Mitarbeiter',
          dataNascita: 'Geboren am',
          luogoNascita: 'Geboren in',
          sesso: 'Sex',
          dataAssunzione: 'Angestellt am',
          dataCessazione: 'Aufgehört am',
          mansione: 'Aufgabe',
          tipoRapp: 'Arbeitsbeziehungstyp'
        }
      },
      en_GB: {
        contestazione: {
          cerca: 'Search',
          nuovoDip: 'New Employee',
          contestazione: 'Employee',
          dataNascita: 'Born on',
          luogoNascita: 'Born in',
          sesso: 'Sex',
          dataAssunzione: 'Hired on',
          dataCessazione: 'Ceased on',
          mansione: 'Task',
          tipoRapp: 'Relationship type'
        }
      }
    }
  },
  props: {
    prefixApp: {
      type: String
    }
  },
  data() {
    return {
      moment: moment,
      loading: false,
      codLang: sessionStorage.getItem('codLang'),
      showSearchPanel: false,
      form: {
        codForn: '',
        fornitore: '',
        codSoc: '',
        codMag: '',
        annoOrd: '',
        numOrd: ''
      },
      contestazioni: [],
      pag_for: 12,
      currentPage: 1,
      nrPages: 0,
      nrItems: 0,
      ordine: '1A',
      desFornitore: '',
      fornitore: ''
    }
  },
  mounted: function () {
    bus.$on('changeLanguage', () => {
      this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
    })
    bus.$on('Header_SetCodFornAdmin', () => {
      this.$set(this, 'contestazioni', [])
      this.$set(this, 'nrPages', 0)
      this.$set(this, 'nrItems', 0)
      this.$set(this, 'currentPage', 1)
    })
    bus.$on('ACCSTA_ChangeCountryFromDsh', () => {
      this.$set(this, 'contestazioni', [])
      this.$set(this, 'nrPages', 0)
      this.$set(this, 'nrItems', 0)
      this.$set(this, 'currentPage', 1)
    })
  },
  activated: function () {
    this.init()
  },
  deactivated: function () {
    this.resetDati()
  },
  methods: {
    init: function () {
      this.$store.dispatch('ifObject', 'CON_Ricerca').then((ifRicerca) => {
        if (ifRicerca) {
          let form = this.$store.state.CON_Ricerca
          this.$set(this, 'form', form)
          this.ricerca()
        }
      })
    },
    resetDati: function () {
      this.$set(this, 'loading', false)
      this.$set(this, 'showSearchPanel', false)
      let form = {
        codForn: '',
        fornitore: '',
        codSoc: '',
        codMag: '',
        annoOrd: '',
        numOrd: ''
      }
      this.$set(this, 'form', form)
      this.$set(this, 'contestazioni', [])
      this.$set(this, 'currentPage', 1)
      this.$set(this, 'pag_for', 12)
      this.$set(this, 'nrPages', 0)
      this.$set(this, 'nrItems', 0)
      this.$set(this, 'ordine', '1A')
      this.$set(this, 'desFornitore', '')
      this.$set(this, 'fornitore', '')
    },
    setLoading: function (val) {
      this.$set(this, 'loading', val)
    },
    openSearch: function () {
      this.$set(this, 'showSearchPanel', true)
      this.$emit('hideScroll')
      this.$emit('closeMessages')
    },
    closeSearch: function () {
      this.$emit('showScroll')
      this.$set(this, 'showSearchPanel', false)
    },
    changePage: function (page) {
      this.$set(this, 'currentPage', page)
      this.ricerca()
    },
    cerca: function (form) {
      let formRicerca = JSON.parse(form)
      this.$set(this, 'form', formRicerca)
      this.$set(this, 'currentPage', 1)
      if (!this._inactive) {
        this.ricerca()
      }
    },
    getDataCont: function (row) {
      if (row.dataCon != '' && row.oraCon != '') {
        return moment(row.dataCon, 'YYYYMMDD').format('DD/MM/YYYY') + " - " + row.oraCon.substr(0, 2) + ':' + row.oraCon.substr(2, 2)
      } else if (row.dataCon != '') {
        return moment(row.dataCon, 'YYYYMMDD').format('DD/MM/YYYY')
      } else {
        return
      }
    },
    sortChange: function ({ column, prop, order }) {
      if (prop === 'dipendente') {
        if (order === 'ascending') {
          this.$set(this, 'ordine', '1A')
        } else if (order === 'descending') {
          this.$set(this, 'ordine', '1D')
        }
      } else if (prop === 'dataAssunzione') {
        if (order === 'ascending') {
          this.$set(this, 'ordine', '2A')
        } else if (order === 'descending') {
          this.$set(this, 'ordine', '2D')
        }
      } else if (prop === 'desMansione') {
        if (order === 'ascending') {
          this.$set(this, 'ordine', '3A')
        } else if (order === 'descending') {
          this.$set(this, 'ordine', '3D')
        }
      } else if (prop === 'tipoRapp') {
        if (order === 'ascending') {
          this.$set(this, 'ordine', '4A')
        } else if (order === 'descending') {
          this.$set(this, 'ordine', '4D')
        }
      }
      this.ricerca(true)
    },
    ricerca: function (flagIfChangeSort) {
      this.$set(this, 'loading', true)
      if (flagIfChangeSort) {
        this.$set(this, 'form', this.$store.state.CON_Ricerca)
        this.$set(this, 'currentPage', 1)
      }

      // Flag per sapere se ho cambiato Stato e/o codForn
      let flagChange = false

      // Se il codForn salvato nel sessionStorage è diverso da quello in utilizzo nel component allora lo cambio
      if (sessionStorage.getItem('ACCSTA_fornitore') !== this.form.codForn) {
        sessionStorage.setItem('ACCSTA_fornitore', this.form.codForn)
        flagChange = true
      }

      // Se lo Stato salvato nel localStorage è diverso da quello in utilizzo nel component allora lo cambio
      if (localStorage.getItem('ACCSTA_country') !== this.form.country) {
        localStorage.setItem('ACCSTA_country', parseInt(this.form.country))
        flagChange = true
      }
      bus.$emit('Header_ChangeAdmin', this.form.country, 'ACCSTA')

      // Sono cambiati Stato e/o codForn
      if (flagChange) {
        bus.$emit('ACCSTA_ChangeCountryFromApp')
      }
      this.$http.get('contestazioni/contestazioni', {
        params: {
          codLang: this.codLang,
          country: this.form.country,
          codForn: this.form.codForn,
          fornitore: this.form.fornitore,
          codSoc: this.form.codSoc,
          codMag: this.form.codMag,
          annoOrd: this.form.annoOrd,
          numOrd: this.form.numOrd,
          pag_action: (this.currentPage > 1) ? 'NEXT' : 'BEGIN',
          pag_from: (this.currentPage - 1) * this.pag_for + 1,
          pag_for: this.pag_for
        }
      })
        .then(response => {
          if (response.body.rc === 0) {
            this.$set(this, 'contestazioni', response.body.data)
            if (this.currentPage === 1) {
              this.$set(this, 'nrItems', parseInt(response.body.attrib.size))

              let resto = parseInt(response.body.attrib.size) % this.pag_for
              let aggiunta = (resto > 0) ? 1 : 0
              let nrPages = Math.floor(parseInt(response.body.attrib.size) / this.pag_for) + aggiunta
              this.$set(this, 'nrPages', nrPages)
            }
          } else {
            this.$set(this, 'contestazioni', [])
            this.$set(this, 'currentPage', 1)
            this.$set(this, 'nrPages', 0)
            this.$set(this, 'nrItems', 0)

            /*this.$message({
              showClose: true,
              message: response.body.msg[0].msgTxt,
              type: 'error',
              duration: process.env.duration
            })*/
          }

          // Salvo comunque la ricerca perchè altrimenti viene creato un oggetto ricerca con solo la desFornitore (riga 445)
          this.$store.commit('set', { key: 'CON_Ricerca', value: this.form })

          if (response.body.attrib && response.body.attrib.fornitore) {
            // Salvo la descrizione del fornitore
            this.$store.commit('setDesFornitore', response.body.attrib.desFornitore)
            this.$set(this, 'fornitore', response.body.attrib.fornitore)
            this.$set(this, 'desFornitore', response.body.attrib.desFornitore)
          }

          this.closeSearch()
          this.$set(this, 'loading', false)
        })
    },
    selectContestazione: function (documento) {
      this.$store.commit('set', { key: 'CON_Contestazione', value: documento })
      this.$router.push({ name: 'CONDettaglioContestazione' })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
@import "../../../../assets/less/general.less";

.contestazioni {
  .header-tab {
    height: 80px;
    text-align: center;

    .icon-search {
      line-height: 80px;

      .el-button {
        height: 40px;
        width: 40px;
        border-radius: 0;
        margin-top: 12px;
        margin-left: 10px;
        padding: 0;
        color: @greenRiva;
        float: left;
        border: 1px solid @greenRiva;
      }

      .el-button:hover {
        background-color: @white;
      }
    }

    .fornitore {
      .set-font(@color: @greenRiva; @size: 16px; @family: 'os-semibolditalic');
      text-align: right;
      margin-top: 12px;
      right: 10px;

      span {
        display: block;
      }

      .fa-icon {
        margin-top: 6px;
        line-height: 30px;
        color: @rossoRiva
      }
    }
  }

  .el-table {
    height: 460px;
    margin-top: 5px;

    .el-table__header {
      thead {
        th {

          // padding: 0 !important;
          .cell {
            .el-popover__reference {
              padding-top: 0;
              line-height: 16px;
            }
          }
        }
      }
    }

    .fa-icon {
      color: @rossoRiva;
      float: right;
    }

    .el-table__row {
      .lente {
        .fa-icon {
          margin-right: 10px;
        }
      }

    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/AccessoStabilimenti/GestioneAppalti/Contestazioni/ElencoContestazioni.vue